/**
 * curriculum.ts — single source of truth for faith-course gating.
 *
 * The whitelist contains category_id values that are permanently free,
 * regardless of whether the user has a bibleSchool entitlement.
 *
 * Rule: free if  isFreeFaithCategory(category_id)
 *       locked if isFaithClass && !bibleSchool && !isFreeFaithCategory(category_id)
 */

/**
 * Category IDs that are always accessible for free (no subscription required).
 * Currently: "Meeting Jesus First" — Course 1 of the Bible Journey catalog.
 */
export const FREE_FAITH_CATEGORY_IDS: readonly string[] = [
  'a0000000-0000-4000-a000-000000000101',
];

/**
 * Returns true if the given category_id is in the free-tier whitelist.
 */
export function isFreeFaithCategory(categoryId: string | null | undefined): boolean {
  if (!categoryId) return false;
  return (FREE_FAITH_CATEGORY_IDS as string[]).includes(categoryId);
}
